import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {FlowChartDataService} from '../../../services/flow-chart-data.service';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommandResponse, PlatformCommand} from '@shared/commands/command-base';
import { DialogModel } from '@shared/models/dialog.model';
import { take, takeUntil } from 'rxjs/operators';
import { DialogService } from '@shared/services/dialog-service';
import { Subject } from 'rxjs';
import { Configuration } from '@shared/models/configuration';
import { HttpClient } from '@angular/common/http';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { CommandService } from '@core/services/command.service';
import {QnrPermissions} from '@features/data-survey/components/flow-chart/models/qnr.models';
import {MenuConfig} from '@features/data-survey/models/flow-chart.model';

@Component({
    standalone: false,
    selector: 'particle-platform-tool-questionnaire-design-group',
  templateUrl: './platform-tool-questionnaire-design-group.component.html',
  styleUrls: ['./platform-tool-questionnaire-design-group.component.scss']
})
export class PlatformToolQuestionnaireDesignGroupComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject = new InvalidateSubject();
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  defaultExpansionPanelIndex = 0;
  sections = [];
  singleSectionOnly: boolean;
  flowchart: any;
  actionEvents: EventEmitter<any> = new EventEmitter<any>();
  menuConfig: MenuConfig;
  hasAddFieldPermission: boolean;

  constructor(public flowChartDataService: FlowChartDataService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private dialogService: DialogService,
              private commandService: CommandService,
              private httpClient: HttpClient) {
    this.menuConfig = new MenuConfig();
  }
  private ngUnsubscribe = new Subject<void>();
  ngOnInit() {
    if (this.selectedTab.tabData && this.selectedTab.tabData['MenuConfig']) {
      this.menuConfig = { ...this.menuConfig, ...this.selectedTab.tabData['MenuConfig']};
    }
    this.flowChartDataService.excludeHiddenQuestions = true;
    this.flowChartDataService.initFlowchartData();
    this.flowChartDataService.invalidateSubject = this.invalidateSubject;
    this.flowChartDataService.setApi(this.selectedTab.tabData.Api);
    this.flowChartDataService.setIsClientDrive(this.selectedTab.tabData['IsClientDrive']);
    this.flowChartDataService.setFlowchartId(this.selectedTab.tabData['FlowChartId']);
    this.flowChartDataService.setIsFillablePdf(this.selectedTab.tabData['IsFillablePdf']);
    this.flowChartDataService.fetchCustomDataTypes(this.selectedTab.tabData['SourceType']);
    this.flowChartDataService.setSourceType(this.selectedTab.tabData['SourceType']);
    this.createConfig(this.selectedTab.tabData);
    console.log('this.selectedTab.tabData[\'IsManageFields\']:' , this.selectedTab.tabData['IsManageFields']);
    if (this.selectedTab.tabData['IsManageFields']) {
      this.flowChartDataService.setIsManageFields(this.selectedTab.tabData['IsManageFields']);
    }
    this.flowChartDataService.setIsManageFields(false);
    this.flowChartDataService.setFieldValues(this.selectedTab.tabData);
    this.singleSectionOnly = this.selectedTab.tabData['SingleSectionOnly'] === true;
    this.flowChartDataService.getInvalidateSubjectObservable().pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.getSections();
    });
    this.getSections();
    console.log(this.flowchart);
  }


  private getSections() {
    if (this.selectedTab.tabData['SingleSectionOnly']) {
      this.getSelectedSections();
    } else {
      this.getAllSections();
    }
  }

  private getAllSections() {
    this.flowChartDataService.getDesignerSingleTopicSections().then(
      data => {
        let openedIndex = this.sections.findIndex(x => x.panelOpenState === true);
        this.sections = data[0];
        if (openedIndex >= 0 && openedIndex < this.sections.length) {
          this.sections[openedIndex].panelOpenState = true;
        }
        this.flowchart = data[1].flowcharts.find(f => f.id === this.selectedTab.tabData['FlowChartId']);
        if (this.sections.length && openedIndex === -1) {
          openedIndex = 0;
        }

        if (openedIndex >= 0 && openedIndex < this.sections.length) {
          this.sections[openedIndex].panelOpenState = true;
        }
        this.updateAddFieldPermission();
      }
      ,
      error => {
        console.error('PlatformToolQuestionnaireDesignGroupComponent error', error);
      }
    );
  }

  private getSelectedSections() {
    const query: any = {};
    query.includeFlowChartsInfo = false;
    query.includeFirstFlowchart = false;
    query.includeSelectedFlowchart = [this.selectedTab.tabData['FlowChartId']];
    query.includeSelectedSections = [this.selectedTab.tabData['SurveyFlowchartSectionId']];
    this.flowChartDataService.getFlowChartInfoByQueryObj(query)
      .pipe(take(1))
      .subscribe(
        data => {
          this.sections = data.flowchartSections[this.selectedTab.tabData['FlowChartId']];
          this.flowchart = data.flowcharts.find(f => f.id === this.selectedTab.tabData['FlowChartId']);

          let openedIndex = this.sections.findIndex(x => x.panelOpenState === true);
          if (this.sections.length && openedIndex === -1) {
            openedIndex = 0;
          }

          if (openedIndex >= 0 && openedIndex < this.sections.length) {
            this.sections[openedIndex].panelOpenState = true;
          }
          this.updateAddFieldPermission();
        }
        ,
        error => {
          console.error('PlatformToolQuestionnaireDesignGroupComponent error', error);
        }
      );
  }

  updateAddFieldPermission() {
    this.hasAddFieldPermission = this.flowChartDataService.hasAddFieldPermission(this.flowchart);

    // for fieldSchema qnr
    if (this.flowchart?.fieldValues && this.flowchart.fieldValues['FieldSchemaId'] && this.flowchart.fieldValues['IsQnr']) {
      this.hasAddFieldPermission = false;
    }
  }

  ngOnDestroy(): void {
    this.flowChartDataService.destroy();
    this.flowChartDataService.clearFieldValues();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {

    // this.singleSectionOnly = this.selectedTab.tabData['SingleSectionOnly'] === true;
  }
  addSection() {
    const dialogModel: DialogModel = DialogModel.create(
      'Add Section',
      'RenameTitleDialogComponent', {
        fieldName: 'Section Name', name: ''
      },
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        this.flowChartDataService.addSectionCommandExecute(res, {flowchartId: this.selectedTab.tabData['FlowChartId']});
      }
    });
  }
  /*deleteSection() {
    const dialogModel: DialogModel = DialogModel.create(
      'Delete Section',
      'DeleteSectionDialogComponent', {
        flowchartId: this.selectedTab.tabData['FlowChartId'],
        section: this.section
      },
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      if (res.action === 'OK') {
        this.flowChartDataService.deleteSectionCommandExecute(res, this.section);
      }
    });
  }


  renameSection() {
    const dialogModel: DialogModel = DialogModel.create(
      'Rename Section',
      'RenameTitleDialogComponent', {
        fieldName: 'Section Name', name: this.section.title
      },
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      if (res.action === 'OK') {
        this.flowChartDataService.renameSectionCommandExecute(res, this.section);
      }
    });
  }*/
  // editSection() {
  //   let openedIndex = this.sections.findIndex(x => x.panelOpenState === true);
  //   if (this.sections.length && openedIndex === -1) {
  //     openedIndex = 0;
  //   }
  //   const dialogModel: DialogModel = DialogModel.create(
  //     'Rename Section',
  //     'PlatformToolEditSectionEditorComponent', {
  //       fieldName: 'Section Name', name: this.sections[openedIndex].title,
  //       description: this.sections[openedIndex].description
  //     },
  //     '765px',
  //     '765px'
  //   );
  //   this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
  //     if (res.action === 'OK') {
  //       this.flowChartDataService.renameSectionCommandExecute(res, this.sections[openedIndex]);
  //       if (res.data && res.data.input) {
  //         const command = this.getActivityCommandForSectionEdit(res, openedIndex);
  //         this.sendActivityTrackCommandForRenameSection(command);
  //       }
  //     }
  //   });
  // }
  // sendActivityTrackCommandForRenameSection(command) {
  //   this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
  //     console.log(response);
  //   });
  // }
  // getActivityCommandForSectionEdit(currentSectionState, openedIndex) {
  //   const currentSectionName = currentSectionState.data.input.name;
  //   const previousSectionName = this.sections[openedIndex].title;
  //   const currentDescription = currentSectionState.data.input.description;
  //   let previousDescription = this.sections[openedIndex].description;
  //   if (previousDescription == null) {
  //     previousDescription = '';
  //   }
  //   const tabData = this.selectedTab.tabData;
  //
  //   const activityCommand = new PlatformCommand('TrackActivityForQuestionnaireDesignCommand', 'FileStoreApi');
  //   activityCommand.fieldValues['DirectoryId'] = tabData['DirectoryId'];
  //   activityCommand.fieldValues['ChangeFieldType'] = [];
  //
  //   if (previousSectionName !== currentSectionName) {
  //     activityCommand.fieldValues['PreviousName'] = previousSectionName;
  //     activityCommand.fieldValues['CurrentName'] = currentSectionName;
  //     activityCommand.fieldValues['ChangeFieldType'].push('SectionTitle');
  //   }
  //
  //   if (previousDescription !== currentDescription) {
  //     activityCommand.fieldValues['SectionName'] = currentSectionName;
  //     activityCommand.fieldValues['ChangeFieldType'].push('SectionDescription');
  //   }
  //
  //   return activityCommand;
  // }

  createConfig(parameters) {

    let smartConfig = Configuration.getSmartGridConfig(parameters['SourceType']);
    if (!smartConfig) {
      smartConfig = {
        'SourceType': parameters['SourceType'],
        'IsCompanySpecific': parameters['IsCompanySpecific'] === true,
        'RootUrlKey': parameters['Api'],
        'ItemsUrlIndex': 0,
        'ItemsUrl': [],
        'Parameters': {},
        'SelectionSettings' : {
          'ShowCheckAll' : parameters['ShowCheckAll'] === true,
          'CheckboxOnly' : parameters['ShowCheckbox'] === true,
          'Mode' : parameters['AllowMultipleCheck'] ? 'multiple' : 'single',
          'Enabled': parameters['ShowCheckbox'] === true
        }

      };
      Configuration.setSmartGridConfig(parameters['SourceType'],  smartConfig);
    }
  }

  hasAddSectionPermission() {
    if (!this.flowchart || !this.flowchart.permissions || !this.flowchart.permissions.length || this.flowchart.permissions.length === 0) {
      return true;
    }
    return this.flowchart.permissions.includes(QnrPermissions.AddSection);
  }
  onActionClicked(type: string) {
    this.actionEvents.emit({type: type});
  }

}
